(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_creditDialogController', Queue_creditDialogController);

    Queue_creditDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Queue_credit'];

    function Queue_creditDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Queue_credit) {
        var vm = this;

        vm.queue_credit = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queue_credit.id !== null) {
                Queue_credit.update(vm.queue_credit, onSaveSuccess, onSaveError);
            } else {
                Queue_credit.save(vm.queue_credit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queue_creditUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
